














import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';

import store from '@/store/store';
import { getModule } from 'vuex-module-decorators';
import { INotification, User, Entry } from '../../types';

@Component
export default class LevelUpNotification extends Vue {
  @Prop(Object) notif: INotification;
}
